import { Protected } from "@/components/layout/Protected";
import { Box, Grid, Container, Typography, IconButton, SelectChangeEvent, Autocomplete, Button, } from '@mui/material'
import { useState } from "react";
import { Props } from "../ElectronicPurchaseInvoice.type"
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import '../ElectronicPurchaseInvoice-styles.css'
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LoadingButton from '@mui/lab/LoadingButton';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { AddCircle } from "@mui/icons-material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BookIcon from '@mui/icons-material/Book';
import WbShadeIcon from '@mui/icons-material/WbShade';
import Modal from '@mui/material/Modal';

interface Column {
   id: 'codigo' | 'rut' | 'razonSocial' | 'nombre' | 'giro'|'stock';
   label: string;
   minWidth?: number;
   align?: 'right';
   format?: (value: number) => string;
}
const columns: readonly Column[] = [
   { id: 'codigo', label: 'Código', minWidth: 10 },
   { id: 'rut', label: 'Barra', minWidth: 100 },
   { id: 'razonSocial', label: 'Razon Social', minWidth: 50 },
   { id: 'nombre', label: 'Nombre', minWidth: 100 },
   { id: 'giro', label: 'Giro', minWidth: 50 },
   { id: 'stock', label: 'Stock', minWidth: 50 },

];
interface Data {
   codigo: string;
   rut: string;
   razonSocial: string;
   nombre: string;
   giro: string;
   stock: string;
}
function createData(
   codigo: string,
   rut: string,
   razonSocial: string,
   nombre: string,
   giro: string,
   stock: string,
): Data {
   return { codigo, rut, razonSocial, nombre, giro,stock };
}

const rowsData = [
   createData('1', '12345678-9', 'Proveedor 1', 'Producto 1', '$1.00','10'),
   createData('2', '12345678-9', 'Proveedor 1', 'Producto 1', '$1.00','100'),
   createData('3', '12345678-9', 'Proveedor 1', 'Producto 1', '$1.00','20'),
   createData('4', '12345678-9', 'Proveedor 1', 'Producto 1', '$1.00','90'),
   createData('5', '123456789', 'Proveedor 1', 'Producto 1', '$1.00','10'),
]

export const DataProvider: React.FC<Props> = (props: Props): JSX.Element => {
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [value, setValue] = useState('');
   const [loading, setLoading] = useState(false);
   const [ejecutivoComercial, setEjecutivoComercial] = useState('');
   const [estado, setEstado] = useState('');

   const handleChangeEjecutivoComercial = (event: SelectChangeEvent) => {
      setEjecutivoComercial(event.target.value);
   };
   const handleChangeEstado = (event: SelectChangeEvent) => {
      setEstado(event.target.value);
   };
   function handleClick() {
      setLoading(true);
   }

   const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
   };

   const estados = [
      { label: 'No Adjudicada', value: 'Enviado' },
      { label: 'Adjudicada', value: 'Adjudicada' },
      { label: 'Anulada', value: 'No Adjudicada' },
   ]
   return (
      <Container maxWidth='xl'>
         <Grid item xs={12} md={12} >
            <Box>
               <Typography variant='h6' component='h1' gutterBottom className="tittle">
                  PROVEEDORES
               </Typography>
            </Box>
            <Box>
               <Typography variant='subtitle2' gutterBottom >
                  Seleccionar Proveedor
               </Typography>
            </Box>
         </Grid>

         <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
               <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                     <TableRow>
                        <TableCell>
                           <TextField
                              id="outlined-basic"
                              label="Codigo"
                              size="small"
                              fullWidth
                           >
                           </TextField>
                        </TableCell>

                        <TableCell>
                           <TextField
                              id="outlined-basic"
                              label="Barra"
                              size="small"
                              fullWidth
                           >
                           </TextField>
                        </TableCell>

                        <TableCell>
                           <TextField
                              id="outlined-basic"
                              label="Proveedor"
                              size="small"
                              fullWidth
                           >
                           </TextField>
                        </TableCell>

                        <TableCell>
                           <TextField
                              id="outlined-basic"
                              label="Descripcion"
                              size="small"
                              fullWidth
                           >
                           </TextField>
                        </TableCell>

                        <TableCell>
                           <TextField
                              id="outlined-basic"
                              label="Precio"
                              size="small"
                              fullWidth
                           >
                           </TextField>
                        </TableCell>

                        <TableCell>
                           <TextField
                              id="outlined-basic"
                              label="Stock"
                              size="small"
                              fullWidth
                           >
                           </TextField>
                        </TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {rowsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        return (
                           <TableRow hover role="checkbox" tabIndex={-1} key={row.codigo}>
                              {columns.map((column) => {
                                 const value = row[column.id];
                                 return (
                                    <TableCell key={column.id} align={column.align}>
                                       {column.format && typeof value === 'number'
                                          ? column.format(value)
                                          : value}
                                    </TableCell>
                                 );
                              })}
                           </TableRow>
                        );
                     })}

                  </TableBody>
               </Table>
            </TableContainer>
            <TablePagination
               rowsPerPageOptions={[10, 25, 100]}
               component="div"
               count={rowsData.length}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Paper>

      </Container>
   );
};

